import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { noHeaderCss } from "../../sass/Main";
import Typography from "@material-ui/core/Typography";

class PaperHeader extends React.Component {
  getHeading = () => {
    if (this.props.heading) {
      return (
        <Typography variant="h2" component="h2" style={{ marginBottom: "0.3em" }}>
          {this.props.heading}
        </Typography>
      );
    }

    return null;
  };

  getText = () => {
    if (this.props.text) {
      const { classes } = this.props;

      return (
        <Typography component="p" className={classes.pSize}>
          {this.props.text}
        </Typography>
      );
    }

    return null;
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.paperHeader}>
        <div className={classes.paperHeaderLogoContainer}>
          {/*<object className={classes.paperHeaderLogo} data="/voicehub-logo.svg" type="image/svg+xml">*/}
          <img className={classes.paperHeaderLogo} src="/images/logos/responsum.png" alt="Responsum" />
          {/*</object>*/}
        </div>
        {this.getHeading()}
        {this.getText()}
      </div>
    );
  }
}

export default withStyles(noHeaderCss)(PaperHeader);
